export const appConfig = {

  NavigationFrom: "",
  STORAGE_OBJECTS: {
    LOGGED_IN_EMPLOYEE: 'loggedInEmployee',
    LOGGED_IN_BUSINESS_LIST: 'loggedInBusinessList',
    LOGGED_IN_CUSTOMER: 'loggedInCustomer',
    SAVED_INVITE: 'saved_invite'
  },
  Relation: {
    Mother: 'Mother',
    Father: 'Father',
    Husband: 'Husband',
    Wife: 'Wife',
    Brother: 'Brother',
    Sister: 'Sister',
    Daughter: 'Daughter',
    Son: 'Son',
  },
  STORAGE_TABLE: {
    DONATION: 'donation',
    PAYMENT: 'payment',
    USER: 'user',
    EMPLOYEE: 'employee',
    BUSINESS: 'business',
    Relative: 'relative',
    UserPd: 'user_pd',
    MASTER: 'master',
    REACTION: 'reaction',
    DESIGNATION: 'designation',
    INVITE: 'invite',
    COMMITTEE: 'committee',
    COMMITTEE_MEMBER: 'committee_member',
    APP_VERSION: 'app_version',
    ACCOUNT_DELETION_REQUESTS: 'account_deletion_requests'

  },

  DEFAULT_ATTACHMENT: {

    DEFAULT: './assets/imgs/add.png',
    LOGO: 'https://firebasestorage.googleapis.com/v0/b/uat-emart-gc.appspot.com/o/static_images%2Flogo_greaves.svg?alt=media',
    USER: 'https://firebasestorage.googleapis.com/v0/b/dev-anutechinfra.appspot.com/o/static_images%2Fimgs%2Fuser_default.png?alt=media',
  },

  gradingLocations: {
    invoiceAcknowledge: "Invoice Acknowledge",
    GRN: "GRN"
  },

  TASK_TYPE: {
    OTHER: 'Other',
    LABOUR: 'Labour',
    PART: 'Spares'
  }
};
